import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PillSpinner from '../components/PillSpinner';

const API_URL = 'http://localhost:5000/api';

const Reminders = () => {
  const [reminders, setReminders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    patientId: '',
    reminderDate: '',
    message: '',
    status: 'Pending'
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    try {
      const [remRes, custRes] = await Promise.all([
        axios.get(`${API_URL}/reminders`),
        axios.get(`${API_URL}/customers`)
      ]);
      setReminders(remRes.data);
      setCustomers(custRes.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API_URL}/reminders/${editingId}`, form);
        alert('Reminder updated');
      } else {
        await axios.post(`${API_URL}/reminders`, form);
        alert('Reminder added');
      }
      setShowForm(false);
      setEditingId(null);
      setForm({ patientId: '', reminderDate: '', message: '', status: 'Pending' });
      fetchAll();
    } catch (err) {
      alert('Error saving reminder');
    }
  };

  const handleEdit = (rem) => {
    setForm({
      patientId: rem.patientId,
      reminderDate: rem.reminderDate.split('T')[0],
      message: rem.message,
      status: rem.status
    });
    setEditingId(rem._id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this reminder?')) {
      await axios.delete(`${API_URL}/reminders/${id}`);
      fetchAll();
    }
  };

  const handleMarkSent = async (rem) => {
    if (rem.status === 'Sent') return;
    await axios.put(`${API_URL}/reminders/${rem._id}`, { ...rem, status: 'Sent' });
    fetchAll();
  };

  const getPatientName = (id) => {
    const patient = customers.find(c => c._id === id);
    return patient ? patient.name : 'Unknown';
  };

  if (loading) return <PillSpinner />;

  const pendingReminders = reminders.filter(r => r.status === 'Pending');
  const sentReminders = reminders.filter(r => r.status === 'Sent');

  return (
    <div className="card">
      <div className="inventory-header">
        <h2>🔔 Refill Reminders</h2>
        <button onClick={() => { setShowForm(!showForm); setEditingId(null); setForm({ patientId: '', reminderDate: '', message: '', status: 'Pending' }); }} className="btn-add">
          {showForm ? 'Cancel' : '+ New Reminder'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="medicine-form" style={{ flexDirection: 'column' }}>
          <select value={form.patientId} onChange={e => setForm({...form, patientId: e.target.value})} required>
            <option value="">Select Patient</option>
            {customers.map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
          </select>
          <input type="date" value={form.reminderDate} onChange={e => setForm({...form, reminderDate: e.target.value})} required />
          <textarea placeholder="Reminder message (e.g., Time to refill your prescription)" value={form.message} onChange={e => setForm({...form, message: e.target.value})} rows="2" required />
          <div>
            <button type="submit" className="btn-submit">{editingId ? 'Update' : 'Save'} Reminder</button>
          </div>
        </form>
      )}

      <h3>📅 Pending Reminders</h3>
      <table className="inventory-table">
        <thead>
          <tr><th>Patient</th><th>Reminder Date</th><th>Message</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {pendingReminders.map(rem => (
            <tr key={rem._id}>
              <td>{getPatientName(rem.patientId)}</td>
              <td>{new Date(rem.reminderDate).toLocaleDateString()}</td>
              <td>{rem.message}</td>
              <td>
                <button onClick={() => handleEdit(rem)} className="btn-edit">Edit</button>
                <button onClick={() => handleMarkSent(rem)} className="btn-sale">Mark Sent</button>
                <button onClick={() => handleDelete(rem._id)} className="btn-restock" style={{ background: '#dc3545' }}>Delete</button>
              </td>
            </tr>
          ))}
          {pendingReminders.length === 0 && <tr><td colSpan="4">No pending reminders.</td></tr>}
        </tbody>
      </table>

      <h3>✅ Sent Reminders (History)</h3>
      <table className="inventory-table">
        <thead>
          <tr><th>Patient</th><th>Sent Date</th><th>Message</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {sentReminders.map(rem => (
            <tr key={rem._id}>
              <td>{getPatientName(rem.patientId)}</td>
              <td>{new Date(rem.reminderDate).toLocaleDateString()}</td>
              <td>{rem.message}</td>
              <td><button onClick={() => handleDelete(rem._id)} className="btn-restock" style={{ background: '#dc3545' }}>Delete</button></td>
            </tr>
          ))}
          {sentReminders.length === 0 && <tr><td colSpan="4">No sent reminders.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};

export default Reminders;